import styled from "@emotion/styled";

import { MDSText, MDSTextColor, MDSTextVariant, MDSTextWeight } from "@/mds";

export const AgentPageHeader = ({ description, title }: { description: string; title: string }) => (
  <StyledHeader>
    <StyledTitle
      as="h1"
      color={MDSTextColor.Primary}
      variant={MDSTextVariant.HeaderM}
      weight={MDSTextWeight.SemiBold}
    >
      {title}
    </StyledTitle>
    <MDSText color={MDSTextColor.Secondary} variant={MDSTextVariant.ParagraphS}>
      {description}
    </MDSText>
  </StyledHeader>
);

const StyledHeader = styled.header`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[1]};
`;

const StyledTitle = styled(MDSText)`
  margin: 0;
`;
